/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path app
 * @description Application views starting point
 *
 * @section 4.1.2
 *
 */
import React from "react";
import { useLocation, useParams } from "react-router-dom";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import useLink from "./../hooks/useLink";
import useLanguageContext from "./../modules/useLanguageContext";
const View = (props: React.PropsWithChildren<{}>) => {
  const params = useParams<{
    id: string;
    meaId: string;
    period: string;
    model: string;
    module: string;
  }>();
  useLanguageContext();
  const sendValue = useAppContext((s) => s.sendValue);
  const ctx = useAppContext();
  const location = useLocation();
  const redirect = useLink();
  const [, tenantSymbol, rootPathElement] = location.pathname.split("/");
  const period = new URLSearchParams(location.search).get("period");
  React.useEffect(() => {
    sendValue("rootUrl", ["", tenantSymbol, rootPathElement].join("/"));
  }, [tenantSymbol, rootPathElement]);
  React.useEffect(() => {
    sendValue("elementId", params.meaId);
  }, [params.meaId]);
  React.useEffect(() => {
    if (period) {
      sendValue("period", period);
    }
  }, [period]);
  React.useEffect(() => {
    sendValue("page", params.id);
  }, [params.id]);
  React.useEffect(() => {
    if (ctx.rtl) {
      document.body.classList.add("arabic");
    } else {
      document.body.classList.remove("arabic");
    }
  }, [ctx.rtl]);
  return <>{props.children}</>;
};
export default View;
